import { useEffect, useState } from "react";
import { Users, BookOpen, TrendingUp, Calendar as CalIcon, ArrowUpRight } from "lucide-react";
import api from "@/lib/api";
import { Link } from "react-router-dom";

const Card = ({ icon: Icon, label, value, sub, testid }) => (
  <div className="bg-[#FDFBF7] rounded-xl p-6 border border-[#E7C2A6]/40" data-testid={testid}>
    <div className="flex items-center justify-between mb-3">
      <span className="text-sm text-[#8A7970]">{label}</span>
      <Icon className="w-5 h-5 text-[#B84F3E]" strokeWidth={1.5}/>
    </div>
    <div className="font-serif text-3xl">{value}</div>
    {sub && <div className="text-xs text-[#8A7970] mt-1">{sub}</div>}
  </div>
);

export default function Overview() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/stats/dashboard").then(r => setStats(r.data)); }, []);

  return (
    <div>
      <div className="mb-8">
        <h1 className="font-serif text-4xl text-[#4A403B]">Namaste, Pushpen-da 🙏</h1>
        <p className="text-[#8A7970] mt-1">Here's how Megh Balika is doing today.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <Card icon={Users} label="Total Leads" value={stats?.total_leads ?? "—"} sub={`${stats?.new_leads ?? 0} new`} testid="stat-leads"/>
        <Card icon={BookOpen} label="Total Bookings" value={stats?.total_bookings ?? "—"} testid="stat-bookings"/>
        <Card icon={TrendingUp} label="Revenue (This Month)" value={`₹${(stats?.revenue_this_month ?? 0).toLocaleString('en-IN')}`} testid="stat-revenue"/>
        <Card icon={CalIcon} label="Nights This Month" value={`${(stats?.weekday_nights_month ?? 0) + (stats?.weekend_nights_month ?? 0)}`} sub={`Weekday ${stats?.weekday_nights_month ?? 0} · Weekend ${stats?.weekend_nights_month ?? 0}`} testid="stat-nights"/>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-[#FDFBF7] rounded-xl p-6 border border-[#E7C2A6]/40">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-serif text-2xl">Upcoming Check-ins</h3>
            <Link to="/admin/bookings" className="text-sm text-[#B84F3E] flex items-center gap-1" data-testid="view-all-bookings">View all <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.5}/></Link>
          </div>
          {stats?.upcoming_checkins?.length ? (
            <div className="space-y-3">
              {stats.upcoming_checkins.map((b) => (
                <div key={b.id} className="flex items-center justify-between py-3 border-b border-[#E7C2A6]/30 last:border-0">
                  <div>
                    <div className="font-medium">{b.guest_name}</div>
                    <div className="text-xs text-[#8A7970]">{b.checkin} → {b.checkout} · {b.nights} nights · {b.room_id}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm">₹{b.total_amount.toLocaleString('en-IN')}</div>
                    <div className="text-xs text-[#8A7970]">{b.payment_status}</div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-[#8A7970] text-sm">No upcoming check-ins yet.</p>
          )}
        </div>

        <div className="bg-[#FDFBF7] rounded-xl p-6 border border-[#E7C2A6]/40">
          <h3 className="font-serif text-2xl mb-4">Quick Actions</h3>
          <div className="grid grid-cols-2 gap-3">
            <Link to="/admin/pricing" className="p-4 rounded-lg border border-[#E7C2A6]/40 hover:bg-[#F5F2EB] text-sm" data-testid="quick-pricing">
              <CalIcon className="w-5 h-5 text-[#B84F3E] mb-2" strokeWidth={1.5}/>
              Update Pricing Calendar
            </Link>
            <Link to="/admin/leads" className="p-4 rounded-lg border border-[#E7C2A6]/40 hover:bg-[#F5F2EB] text-sm" data-testid="quick-leads">
              <Users className="w-5 h-5 text-[#B84F3E] mb-2" strokeWidth={1.5}/>
              View New Leads
            </Link>
            <Link to="/admin/campaigns" className="p-4 rounded-lg border border-[#E7C2A6]/40 hover:bg-[#F5F2EB] text-sm" data-testid="quick-campaigns">
              <TrendingUp className="w-5 h-5 text-[#B84F3E] mb-2" strokeWidth={1.5}/>
              Manage Offers
            </Link>
            <Link to="/admin/chat" className="p-4 rounded-lg border border-[#E7C2A6]/40 hover:bg-[#F5F2EB] text-sm" data-testid="quick-chat">
              <BookOpen className="w-5 h-5 text-[#B84F3E] mb-2" strokeWidth={1.5}/>
              Test AI Chatbot
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
